import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Button,
    Alert,
} from "reactstrap";
import { useForm } from "react-hook-form";
import LoaderCustom from "../../../common/LoaderCustom";
import { apiErrors, handleBase64Download, notify, userDetails } from "../../../../helper";
import { API } from "../../../../config/constants";
import axiosHelper from "../../../../axiosHelper";


function MasterUpdateRequestsDetail(props) {
    let { vendorMasterUpdateSection } = props;
    const [masterUpdateDetail, setMasterUpdateDetail] = useState(null);
    let isHighlighted;

    if (masterUpdateDetail?.RequestType === 1) {
        isHighlighted = true; // Highlight for RequestType 1
    } else if (masterUpdateDetail?.RequestType === 2) {
        isHighlighted = true; // Highlight for RequestType 2
    } else if (masterUpdateDetail?.RequestType === 3) {
        isHighlighted = true; // Highlight for RequestType 3
    } else if (masterUpdateDetail?.RequestType === 4) {
        isHighlighted = true; // Highlight for RequestType 4
    } else {
        isHighlighted = false; // No highlight for other types
    }
    

    const [showTabLoader, setShowTabLoader] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const requestId = urlParams.get("requestId");
        getMasterUpdateDetail(requestId)
    }, []);

    const getMasterUpdateDetail = (requestId) => {
        axiosHelper.get(`${API.getMasterUpdateDetail}?requestId=${requestId}`)
            .then(async (response) => {
                if (response?.data?.IsSuccessful) {
                    setShowTabLoader(false)
                    setMasterUpdateDetail(response?.data?.Data)
                    props.setMasterUpdateDetail(response?.data?.Data)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                  }else{
                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage)
                    }
                  }
                

            });
    }

    return (
        <>
            <div className="content-page w-100">
                {showTabLoader && <LoaderCustom />}
                <Row className={`filter-row-large`}>
                    <Col md="4" className="mb-2">
                        <h1>View Application Details</h1>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} span={12}>
                        <Row className="non-registered-supplier-details-right text-left">
                            <Col xs={12} sm={12} md={12}>
                                <Row noGutters className="hl-update-details-header">
                                    <Col span={12} md={4}>
                                        <h3 className="sd-common-heading">Update Details</h3>
                                    </Col>
                                    <Col span={12} md={4}>
                                        <h3 className="sd-common-heading">Existig data with Havells</h3>
                                    </Col>
                                    <Col span={12} md={4}>
                                        <h3 className="sd-common-heading">Latest data submitted by supplier</h3>
                                    </Col>
                                </Row>
                                <Row noGutters className="hl-detail-column mt-2">
                                    <Col span={12}><h3 className="sd-common-heading">Supplier Details:</h3></Col>
                                    <Col md="12">
                                        <Row noGutters className="m-0">
                                            <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                <span className="hl-title-details">Supplier Code</span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <span className="hl-desc-details">
                                                    {
                                                        masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.VendorCode ? masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.VendorCode : ""
                                                    }
                                                </span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <div className="hl-desc-details">
                                                </div>
                                            </Col>

                                            <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                <span className="hl-title-details">Supplier Name</span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <span className="hl-desc-details">
                                                    {
                                                        masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.SupplierName ? masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.SupplierName : ""
                                                    }
                                                </span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <div className="hl-desc-details">
                                                </div>
                                            </Col>

                                            <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                <span className="hl-title-details">Pan No.</span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <span className="hl-desc-details">
                                                    {
                                                        masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.PanNo ?
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.PanNo : ""
                                                    }
                                                </span>
                                            </Col>

                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <div className="hl-desc-details">
                                                </div>
                                            </Col>

                                            <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                <span className="hl-title-details">GSTIN No. </span>
                                            </Col>
                                            <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                <span className="hl-desc-details">
                                                    {
                                                        masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.GSTIN ?
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBasicDetailChangeModel?.GSTIN : ""
                                                    }
                                                </span>
                                            </Col>


                                        </Row>
                                    </Col>
                                </Row>

                                <Row noGutters className="hl-detail-column m-0">
                                    <div className={`addressWrapper ${vendorMasterUpdateSection === "address" ? "active" : ""} ${masterUpdateDetail?.RequestType === 4 && 'hl-box-highlight'}`}>
                                        <Col span={12}><h3 className="sd-common-heading">Work Address:(As per GST certificate)</h3></Col>
                                        <Col md="12">
                                            <Row noGutters className="m-0">
                                                <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                    <span className="hl-title-details">Building/Plot No.</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.BuildingPlotNo ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.BuildingPlotNo : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.BuildingPlotNo}
                                                        {
                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.WorkAddressAttachment?.base64String && (
                                                                <button
                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                                                                    onClick={(e) => handleBase64Download(masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.WorkAddressAttachment?.base64String,
                                                                        masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.WorkAddressAttachment?.fileName,
                                                                        masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.WorkAddressAttachment?.fileType
                                                                    )}
                                                                    title="Download"
                                                                >
                                                                    <div className="download mr-0"></div>
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Street</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.Street ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.Street : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="d-flex align-items-center hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.Street}

                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">
                                                        City
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.City ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.City : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.City}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">District</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.District ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.District : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.District}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Country</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.CountryName ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.CountryName : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.CountryName}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">State/Region</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.StateName ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.StateName : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.StateName}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Postal Code/Zip Code</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.PostalCode ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.PostalCode : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details"><span className="hl-desc-details">
                                                    {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.PostalCode}
                                                </span></Col>


                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Relationship of requester with supplier</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.RelationshipOfRequesterWithSupplier ? masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateAddressChange?.RelationshipOfRequesterWithSupplier : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateAddressChange?.RelationshipOfRequesterWithSupplier}
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={12} >
                                            <p className="text-danger p-3 py-2">
                                                <small className="font-normal">
                                                    Please Attach GSTR-06 Registration Certificate for address change.
                                                </small>
                                            </p>
                                        </Col>
                                    </div>

                                    <div className={`emailWrapper ${vendorMasterUpdateSection === "email" ? "active" : ""}  ${masterUpdateDetail?.RequestType === 3 && 'hl-box-highlight'}`}>
                                        <Col span={12}><h3 className="sd-common-heading">Email Change:</h3></Col>
                                        <Col md="12">
                                            <Row noGutters className="m-0">
                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Email For Financial Communication</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange.EmailForFinancialCommunication ? masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange.EmailForFinancialCommunication : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateEmailChange?.EmailForFinancialCommunication}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Email For Quality Communication</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange.EmailforQualityCummunication ? masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange.EmailforQualityCummunication : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateEmailChange?.EmailforQualityCummunication}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Relationship of requester with supplier</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange?.RelationshipOfRequesterWithSupplier ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateEmailChange?.RelationshipOfRequesterWithSupplier : ""
                                                        }
                                                    </span>
                                                </Col>

                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateEmailChange?.RelationshipOfRequesterWithSupplier}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </div>

                                    <div className={`mobileWrapper ${vendorMasterUpdateSection === "mobile" ? "active" : ""}  ${masterUpdateDetail?.RequestType === 2 && 'hl-box-highlight'}`}>
                                        <Col span={12}><h3 className="sd-common-heading">Mobile Number Change:</h3></Col>
                                        <Col md="12">
                                            <Row noGutters className="m-0">
                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Contact Number</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateMobileNumberChange?.ContactNumber ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateMobileNumberChange?.ContactNumber : ""
                                                        }
                                                    </span></Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.ContactNumber}
                                                        {
                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.PhoneBillDocument?.base64String && (
                                                                // <button
                                                                //     className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                                                                //     onClick={(e) => handleBase64Download(masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.PhoneBillDocument?.base64String)}
                                                                //     title="Download"
                                                                // >
                                                                //     <div className="download mr-0"></div>
                                                                // </button>
                                                                <button
                                                                    className="btn btn-secondary hl-download-btn hl-upload-btn ml-4"
                                                                    onClick={() =>
                                                                        handleBase64Download(
                                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.PhoneBillDocument?.base64String,
                                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.PhoneBillDocument?.fileName,
                                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.PhoneBillDocument?.fileType,

                                                                        )
                                                                    }
                                                                    title="Download"
                                                                >
                                                                    <div className="download mr-0"></div>
                                                                </button>
                                                            )
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Relationship of requester with supplier</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateMobileNumberChange?.RelationshipOfRequesterWithSupplier ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateMobileNumberChange?.RelationshipOfRequesterWithSupplier : ""
                                                        }
                                                    </span>
                                                </Col>

                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateMobileNumberChange?.RelationshipOfRequesterWithSupplier}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={12} >
                                            <p className="text-danger p-3 py-2">
                                                <small className="font-normal">
                                                    Attach latest Mobile bill copy.
                                                </small>
                                            </p>
                                        </Col>
                                    </div>
                                    <div className={`bankDetailsWrapper ${vendorMasterUpdateSection === "bankDetails" ? "active" : ""}  ${masterUpdateDetail?.RequestType === 1 && 'hl-box-highlight'}`}>
                                        <Col span={12}><h3 className="sd-common-heading">
                                            Bank Details:
                                            {/* <p>
                                                <small className="font-normal">
                                                    In case change in Bank Details, please send the original hard copy of cancel cheque to Havells Noida Corporate office - MDM department
                                                </small>
                                            </p> */}
                                        </h3>
                                        </Col>
                                        <Col md="12">
                                            <Row noGutters className="m-0">
                                                <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                    <span className="hl-title-details">Bank Name</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.BankName ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.BankName : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="d-flex align-items-center hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.BankName}
                                                        {
                                                            masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.CancelledChequeAttachment?.base64String && (
                                                                <button
                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                                                                    onClick={(e) => handleBase64Download(masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.CancelledChequeAttachment?.base64String,
                                                                        masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.CancelledChequeAttachment?.fileName,
                                                                        masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.CancelledChequeAttachment?.fileType
                                                                    )}
                                                                    title="Download"
                                                                >
                                                                    <div className="download mr-0"></div>
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center"><span className="hl-title-details">Bank No. (IFSC Code)</span></Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.IFSCCode ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.IFSCCode : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.IFSCCode}
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="hl-heading-details d-flex align-items-center">
                                                    <span className="hl-title-details">Bank Account No.</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.AccountNumber ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.AccountNumber : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="d-flex align-items-center hl-desc-details">
                                                        <div className="fullinput-icon">
                                                            {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.AccountNumber}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="hl-heading-details">
                                                    <span className="hl-title-details">Relationship of requester with supplier</span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <span className="hl-desc-details">
                                                        {
                                                            masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.RelationshipOfRequesterWithSupplier ?
                                                                masterUpdateDetail?.MasterUpdateOldDetailModel?.MasterUpdateBankDetailChange?.RelationshipOfRequesterWithSupplier : ""
                                                        }
                                                    </span>
                                                </Col>
                                                <Col xs={12} md={4} className="pr-6 hl-descmain-details">
                                                    <div className="hl-desc-details">
                                                        {masterUpdateDetail?.MasterUpdateNewDetailModel?.MasterUpdateBankDetailChange?.RelationshipOfRequesterWithSupplier}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={12} >
                                            <p className="text-danger p-3 py-2">
                                                <small className="font-normal">
                                                    Please send the original hard copy of cancel cheque to Havells Noida Corporate office - MDM department.
                                                </small>
                                            </p>
                                        </Col>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    );
}
export default MasterUpdateRequestsDetail;
